import { InputData, Task, TasksByMonth } from "../types";



function getMonthName(monthNumber: string): string {
    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ] as const;
    const index = parseInt(monthNumber) - 1;
    if (index >= 0 && index < months.length) {
        const month = months[index];
        if (month) {
            return month;
        }
    }
    throw new Error(`Invalid month number: ${monthNumber}`);
}

export function groupTasksByMonth(data: InputData): TasksByMonth {
    const tasksByMonth: TasksByMonth = {};

    // Iterate through each key in the input data (is_1_month, is_2_month, etc.)
    Object.keys(data).forEach(key => {
        const monthData = data[key];
        if (!monthData) return;
        const tasks = monthData.data;

        // Process each task within this month key
        tasks.forEach(task => {
            // Extract the year and month from the 'when' date (format: 'YYYY-MM-DD')
            const dateParts = task.when.split('-');
            const yearMonth = `${dateParts[0]}-${dateParts[1]}`; // 'YYYY-MM' format

            // If this month doesn't exist in our result object yet, create it
            if (!tasksByMonth[yearMonth]) {
                tasksByMonth[yearMonth] = [];
            }

            // Add this task to the appropriate month
            tasksByMonth[yearMonth].push(task);
        });
    });

    return tasksByMonth;
}


export function getTasksWithReadableMonths(groupedTasks: TasksByMonth): { [key: string]: Task[] } {
    const result: { [key: string]: Task[] } = {};
    
    Object.entries(groupedTasks).forEach(([yearMonth, tasks]) => {
        const parts = yearMonth.split('-');
        if (parts.length === 2) {
            const [year, month] = parts;
            if (year && month) {
                const readableMonth = `${getMonthName(month)} ${year}`;
                result[readableMonth] = tasks;
            }
        }
    });
    
    return result;
}

